import React from 'react';
import {HStack} from '../../Stack';
import {zIndex} from '../../../utils';

import {IconButton} from '../../IconButton';
import {CollapseDefaultIcon, ExpandDefaultIcon} from '../../../icons';

import {ModalCloseButton} from '../ModalCloseButton';

export const ModalActions = ({
  hasCloseButton,
  hasFullScreenToggle,
  isFullScreen,
  toggleIsFullScreen,
}: {
  hasCloseButton?: boolean;
  hasFullScreenToggle?: boolean;
  isFullScreen: boolean;
  toggleIsFullScreen: () => void;
}) => {
  if (!hasFullScreenToggle && !hasCloseButton) {
    return null;
  }

  return (
    <HStack
      justify="end"
      position="absolute"
      right="$2"
      spacing={1}
      top="$2"
      width="fit-content"
      zIndex={zIndex.modalCloseButton}
    >
      {hasFullScreenToggle ? (
        <IconButton
          Icon={isFullScreen ? CollapseDefaultIcon : ExpandDefaultIcon}
          label={isFullScreen ? 'Collapse' : 'Expand'}
          onClick={toggleIsFullScreen}
          variant="ghost"
        />
      ) : null}
      {hasCloseButton ? (
        <ModalCloseButton _shouldUseLegacyPosition={false} />
      ) : null}
    </HStack>
  );
};
